import React from "react";
import ForSaleEssentialsDetails from "./for-sale-essentials-details/for-sale-essentials-details";

const ForSaleEssentialsDetailsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForSaleEssentialsDetails/>
            </div>
        </>
    )
};

export default ForSaleEssentialsDetailsContainer;